<template>
    <div class="panel-search">
        <div class="search input-group">
            <input type="text" class="form-control" v-model="query" @keypress.enter="search" :placeholder="placeholder">
            <div class="input-group-btn">
                <button type="button" class="btn btn-search" @click="search">
                    <span class="glyphicon glyphicon-search"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PanelSearch',
        props: {
            placeholder: {
                type: String,
                default: 'Поиск...',
            },
        },
        data(){
            return {
                query: '',
            }
        },
        methods: {
            search(e) {
                if (e.type == 'keypress') e.preventDefault()
                this.$emit('search', this.query)
            },
        },
    }
</script>

<style lang="less">
    @import "../../less/_boot";

    .panel-search {
        padding: 15px 23px;
        background-color: @gray-lightest;
    }

    .panel-search-light {
        background-color: #fff;
    }

    .search {
        max-width: 620px;
        input {
            color: #8e8e8e;
            .placeholder(#8e8e8e);
        }
        .btn-search {
            color: #fff;
            background-color: #a2a2a2;
            padding-left: 24px;
            padding-right: 24px;
        }
    }
</style>



// WEBPACK FOOTER //
// PanelSearch.vue?2ae0b694